import memoize from 'lodash/memoize';
/**
 * Memoize method decorator - memoises the result of calculations in the method and reuses it when the same arguments are passed
 * @returns MethodDecorator
 * ```
 *  import { Memoize } from '@emobg/web-utils';
 * ```
 * ```@Memoize()```\
 * ```myExpensiveMethod()```
*/
export function Memoize(resolver) {
    return function (_target, _propertyKey, descriptor) {
        descriptor.value = memoize(descriptor.value, resolver);
        return descriptor;
    };
}
